import { useContext } from "react";
import DropdownCore from "./components/DropdownCore";
import DropdownItem from "./components/DropdownItem";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit2 } from "react-icons/fi";
import modalContext from "../../../dataManager/context/modalContext";
import { BsShare } from "react-icons/bs";

const ProductDropdownAdmin = ({ productId }) => {
  //context variables
  const { handleOpenModal } = useContext(modalContext);

  return (
    <DropdownCore>
      <DropdownItem
        icon={<FiEdit2 size={17} />}
        title="Modifier"
        onClick={() =>
          handleOpenModal("EDIT_PRODUCT", "Modifier le produit", {
            productId,
          })
        }
      />
      <DropdownItem
        icon={<AiOutlineDelete size={18} />}
        title="Supprimer"
        onClick={() =>
          handleOpenModal("DELETE_PRODUCT", "Supprimer le produit", {
            productId,
          })
        }
      />
      <DropdownItem
        icon={<BsShare size={15} />}
        title="Partager"
        onClick={() =>
          handleOpenModal("SHARE_PRODUCT", "Partager cet article", {
            productId,
          })
        }
      />
    </DropdownCore>
  );
};

export default ProductDropdownAdmin;
